<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入关键字"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;loadCertiManageList()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.certitype"
                       placeholder="请选择证书类型"
                       clearable
                       filterable
                       @clear="
                () => {
                  delete this.queryObj.certitype;
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadCertiManageList();
                }
              ">
              <el-option v-for="item in certiType"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>


      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="certiTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="userName"
                       label="人员名称">
      </el-table-column>
      <el-table-column prop="certitypeName"
                       label="证书类型">
      </el-table-column>
      <el-table-column prop="certiname"
                       label="证书名称">
      </el-table-column>
      <el-table-column prop="certicode"
                       label="证书编码">
      </el-table-column>
      <el-table-column prop="issuorgan"
                       label="发证机关">
      </el-table-column>
      <el-table-column prop="issudate"
                       label="发证日期">
      </el-table-column>
      <el-table-column prop="valienddate"
                       label="到期日期">
      </el-table-column>
      <el-table-column prop="valiendday"
                       align="center"
                       width="100"
                       label="有效天数">
                       <template slot-scope="scope">
                <el-tag v-if="scope.row.valiendday<0"
                        size="mini"
                        type="warning">已到期</el-tag>
                <el-tag v-else
                        size="mini"
                        type="">{{scope.row.valiendday}}</el-tag>
              </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadCertiManageList()}">
      </es-pagination>
    </div>
    <!--编辑人员证书-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['certiForm'].clearValidate()"
               width="850px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑人员证书
      </span>
      <el-form :model="certiInfo"
               :rules="rules"
               :inline="true"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="certiForm">
        <el-form-item prop="certitype"
                label="证书类型">
            <el-select ref="certitypeSelect"
                       style="width: 200px"
                       v-model="certiInfo.certitype"
                       placeholder="请选择证书类型"
                       clearable
                       filterable>
              <el-option v-for="item in certiType"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item prop="certiname"
                      label="证书名称">
          <el-input v-model="certiInfo.certiname"
                    placeholder="请输入证书名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="certicode"
                      label="证书编码">
          <el-input v-model="certiInfo.certicode"
                    placeholder="请输入证书编码"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="issuorgan"
                      label="发证机关">
          <el-input v-model="certiInfo.issuorgan"
                    placeholder="请输入发证机关"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="issudate"
                      label="发证日期">
          <el-date-picker v-model="certiInfo.issudate"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 200px"
                            placeholder="选择发证日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item prop="valienddate"
                      label="到期日期">
            <el-date-picker v-model="certiInfo.valienddate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 200px"
                  placeholder="选择到期日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item prop="title"
                      label="证书附件">
          <el-col>
            <es-img :info="certiInfo"
                    v-if="editVisible"
                    :fileList="fileList"
                    style="width: 560px"
                    busCode="certi"
                    dataUrl="/base/userCerti/edit_attach_imgs"
                    type="edit"
                    :max="3"
                    tip="图片大小不能超过5MB。"
                    @insertAttachImgs="(attachImgs)=>{this.$set(this.certiInfo, 'attachImgs', attachImgs)}"></es-img>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitCerti()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'certimanage',
  props: ["funcs","paramId"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      userInfo:{},
      pageData: {},
      certiType:[],
      editVisible: false,
      certiInfo: {},//系统信息
      rules: {//验证条件
        certiname: [
          { required: true, message: '请输入证书名称', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        certitype: [
          { required: true, message: '请选择证书类型', trigger: 'blur' }          
        ],
        certicode: [
          { required: true, message: '请输入证书编码', trigger: 'blur' }
        ],
        issuorgan: [
          { required: true, message: '请输入发证机关', trigger: 'blur' }
        ],
        issudate: [
          { required: true, message: '请选择发证日期', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
      fileList: [],
      fileListView: [],
    }
  },
  methods: {
    //页面初始化
    init () {
      this.userInfo = this.paramId
      this.$set(this.queryObj, "emplid", this.paramId.userId);
      this.loadCertiManageList()
      this.loadCertiTypeList();
    },
    //从后台查询系统专业列表
    loadCertiManageList () {
      this.loading = true
      let _this = this
      this.$ajax.get('/base/userCerti/list', this.queryObj).then(msg => {
        msg.list.forEach(function(item) {
          item.userName = _this.userInfo.userName
        });
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    //初始化证书类型下拉框
    loadCertiTypeList () {
      this.$ajax
        .get("/base/certi/list_all")
        .then((msg) => {
          this.certiType = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    add_init () {
      this.editVisible = true
      this.certiInfo = {}
    },
    edit_init (row) {
      this.editVisible = true
      this.certiInfo = JSON.parse(JSON.stringify(row))
      if (this.certiInfo.attachImgs != null && this.certiInfo.attachImgs != '') {
        this.fileList = JSON.parse(this.certiInfo.attachImgs)
        console.log("this.fileList", this.fileList)
        this.fileList.forEach(e => {
          e.url = this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token
        })
      }
    },
    submitCerti () {
      this.$refs["certiForm"].validate(valid => {
        if (valid) {
          let url = "/base/userCerti/add";
          if (this.certiInfo.id != null) {
            url = "/base/userCerti/edit";
          }
          this.certiInfo.emplid = this.userInfo.userId
          this.saving = true
          this.$ajax.post(url, this.certiInfo).then(msg => {
            this.saving = false
            this.loadCertiManageList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["certiTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/userCerti/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadCertiManageList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
